<template>
  <avs-card  class="pb-4">
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar bgTable"
        elevation="0"
      >
        <v-text-field
          class="mr-8"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
          @input="debouncedSearch"
        />
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10 bgTable"
        :headers="headers"
        :items="users"
        :loading="loading && page === 1"
        loading-text="Loading invitaions ..."
        no-data-text="No invitation found"
        disable-pagination
        hide-default-footer
      >
        <template #item.date_joined="{ item }">
          {{ toDatetime(item.date_joined) }}
        </template>
        <template v-slot:item.activation="{ item }">
          <v-btn
            class="mr-2 align-center black white--text"
            @click="handleOpenDialog(item)"
          >
            activate
          </v-btn>
        </template>
      </v-data-table>

      <!-- Loader scroll infini -->
      <div class="py-4 d-flex justify-center" v-if="loadingMore">
        <v-progress-circular indeterminate color="primary" />
      </div>

      <!-- Fin de liste -->
      <div
        v-if="!loading && !loadingMore && !hasMore && users.length"
        class="text-center grey--text py-4"
      >
        {{ $t('Fin de la liste') }}
      </div>

      <!-- Sentinelle pour IntersectionObserver -->
      <div ref="sentinel" style="height:1px;"></div>

      <v-dialog
        v-model="activationDialog"
        width="500"
        height="500"
      >
        <v-card>
          <v-card-title class="text-h5">
            Activation
            <v-spacer></v-spacer>
            <v-btn
              fab
              text
              @click="activationDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text
            class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
            align="center"
          >
            Do you want to activate the account of
            {{ selectedAccount.first_name }} {{ selectedAccount.last_name }} ?
          </v-card-text>
          <v-card-actions class="justify-center mt-10">
            <v-btn
              :style="{
                paddingLeft: '80px',
                paddingRight: '80px'
              }"
              text
              x-large
              class="mb-10 black white--text"
              @click="confirmActivation(selectedAccount)"
            >
              Activate
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </avs-card>
</template>

<script>
import AdminServices from "@/services/AdminServices"
import { toDatetime } from "@/utils/datetime"
import debounce from "lodash/debounce"

export default {
  name: "AdminValidation",
  data() {
    return {
      headers: [
        { text: "Prenom", value: "first_name", align: "start" },
        { text: "Nom", value: "last_name" },
        { text: "Email", value: "email" },
        { text: "Entreprise", value: "company" },
        { text: "Date d'inscritpion", value: "date_joined" },
        { text: "Action", value: "activation", align: "center", sortable: false }
      ],
      activationDialog: false,
      users: [],
      loading: false,
      loadingMore: false,
      search: "",
      selectedAccount: {},
      page: 1,
      hasMore: true,
      observer: null,
    }
  },
  created() {
    this.debouncedSearch = debounce(() => this.fetchReset(), 400)
  },
  mounted() {
    this.fetchReset()
    this.$nextTick(this.createObserver)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
  },
  methods: {
    toDatetime,
    handleOpenDialog(account) {
      this.activationDialog = true
      this.selectedAccount = account
    },
    confirmActivation(user) {
      let data = { is_active: true }
      AdminServices.validateUser(this, user.id, data).then(() => {
        this.fetchReset()
      })
      this.activationDialog = false
    },

    async fetchData({ reset = false } = {}) {
      if (reset) this.loading = true
      else this.loadingMore = true

      try {
        const params = { page: this.page }
        if (this.search) params.search = this.search

        const r = await AdminServices.getPendingValidations(this, params)
        const results = r?.results || []

        this.users = reset ? results : this.users.concat(results)
        this.hasMore = !!(r && r.next)
      } catch (e) {
        if (e?.response?.status === 404) this.hasMore = false
        console.error("Erreur chargement validations:", e)
      } finally {
        this.loading = false
        this.loadingMore = false
        this.$nextTick(() => {
          if (this.hasMore && this.observer && this.$refs.sentinel) {
            this.observer.unobserve(this.$refs.sentinel)
            this.observer.observe(this.$refs.sentinel)
          }
        })
      }
    },

    fetchReset() {
      this.page = 1
      this.hasMore = true
      this.users = []
      this.fetchData({ reset: true })
    },

    createObserver() {
      const el = this.$refs.sentinel
      if (!el) return
      this.observer = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) this.loadMore() },
        { root: null, rootMargin: "200px", threshold: 0.1 }
      )
      this.observer.observe(el)
    },

    loadMore() {
      if (this.loading || this.loadingMore || !this.hasMore) return
      this.page += 1
      this.fetchData()
    },
  }
}
</script>
